import { authenticate, instance } from "@/lib/axios";
import { AxiosRequestConfig } from "axios";
import { PaginatedResult } from "@/types";

export const api = {
  get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return instance.get<T>(url, config).then((res) => res.data);
  },
  post<T>(url: string, payload?: object, config?: AxiosRequestConfig): Promise<T> {
    return instance.post<T>(url, payload, config).then((res) => res.data);
  },
  put<T>(url: string, payload?: object): Promise<T> {
    return instance.put<T>(url, payload).then((res) => res.data);
  },
  delete<T>(url: string, payload?: object): Promise<T> {
    return instance.delete<T>(url, payload).then((res) => res.data);
  },
  authenticate(payload?: object) {
    return authenticate(payload);
  },
  getPaginated<T>(url: string, params?: object): Promise<PaginatedResult<T>> {
    return instance.get<T>(url, params).then((res) => ({
      results: res.data,
      total: Number(res.headers["x-total-count"]),
      page: Number(res.headers["x-current-page"]),
    }));
  },
};
